import React, { useState, useRef, useEffect } from 'react';
import { BiChevronDown } from 'react-icons/bi';
import { AiOutlineSearch } from 'react-icons/ai';
import { MdAddBox } from 'react-icons/md';
import { useCurrent } from '../../hooks';
import CustomerSelectorItem from '../CustomerSelectorItem';

const MwSelector = ({
    label, _data, dataType, onClickNew, setSelectedItem, selectedItem,
    initalValue = 'Choose', withSearch = true, withLabel = true,
    withAddNew = true, className, styleList, invalid, invalidMsg, classnameSelect,
    disabled = false, listClassName = '',
}) => {
    const [inputValue, setInputValue] = useState('');
    const { currentLangId } = useCurrent();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const hasOptions = Array.isArray(_data) && _data.length > 0;
    const isInteractive = !disabled && hasOptions;
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return '';
        return String(value).trim();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (!isInteractive) setOpen(false);
    }, [isInteractive]);

    const onSelectedHandler = (item) => {
        setSelectedItem({ ...item, label: item.label });
        setOpen(false);
        setInputValue('');
    };

    const currentSelectedOption = _data?.find(
        (item) => normalizeValue(item.value) === normalizeValue(selectedItem?.value)
    );
    const currentSelectedLabel = currentSelectedOption?.label;

    const dataList = _data?.map((item, index) => {
        if (dataType === 'customer' || dataType === 'salesman') {
            return (
                <CustomerSelectorItem 
                    key={item._id}
                    item={item} 
                    setSelectedItem={setSelectedItem} 
                    setOpen={setOpen}
                    setInputValue={setInputValue}
                    inputValue={inputValue}
                />
            );
        }
        if (dataType === 'labelValue' && item?.lang?.trim() === currentLangId) {
            const optionClassName = item?.optionClassName || '';
            return (
                <div 
                    className={`px-4 py-2 border-b text-[14px]
                        ${item?.disabled ? 'cursor-pointer bg-gray-100 text-gray-400 hover:bg-gray-200' : 'cursor-pointer hover:bg-[#9c88e1] hover:text-white'}
                        ${item?.label?.toLowerCase().startsWith(inputValue) ? 'block' : 'hidden'} ${optionClassName}`} 
                    key={index} 
                    onClick={() => onSelectedHandler(item)}
                    aria-disabled={item?.disabled ? 'true' : 'false'}
                >
                    {item.label}
                </div>
            );
        }
        return null;
    });

    return (
        <div className={`relative mt-1 ${className}`} ref={ref}>
            {withLabel && <label className='text-xs font-normal px-1 text-[#261759]'>{label}</label>}
            <div
                onClick={() => {
                    if (isInteractive) setOpen(!open);
                }}
                className={`h-9 cursor-pointer mt-0 flex text-xs bg-white font-[600] border-[1px] rounded-md border-[#8D82B6] border-opacity-55 text-[#bfbec1] w-full px-2 items-center justify-between  
                ${classnameSelect} ${invalid ? 'border-red-500' : `border-[#8D82B6] border-opacity-55 ${classnameSelect}`} ${styleList} ${
                    disabled ? 'bg-gray-100 cursor-not-allowed opacity-70' : !hasOptions ? 'cursor-default' : ''
                }`}
            >
                {currentSelectedLabel ? (
                    <span
                        className={`font-normal ${
                            currentSelectedOption?.labelClassName ||
                            (currentSelectedOption?.disabled
                                ? 'text-gray-400'
                                : 'text-[#261759]')
                        }`}
                    >
                        {currentSelectedLabel}
                    </span>
                ) : (
                    initalValue
                )}
                <BiChevronDown size={20} className={!hasOptions ? 'opacity-50' : ''} />
            </div>
            {open && hasOptions && (
                <ul className={`absolute top-full left-0 w-full bg-[#EBF9D9] text-[#261759] cursor-pointer rounded-lg shadow-xl z-[9999] border border-gray-300 mt-1 max-h-60 overflow-y-auto ${listClassName}`}>
                    {withSearch && (
                        <div className='sticky top-0 bg-white p-2 border-b border-gray-300'>
                            {withAddNew && (
                                <div className='text-end'>
                                    <button 
                                        className='text-blue-600 hover:text-blue-800 transition'
                                        onClick={() => { onClickNew(); setOpen(false); }}
                                    >
                                        <MdAddBox size={24} />
                                    </button>
                                </div>
                            )}
                            <div className='flex items-center px-2 bg-gray-100 rounded border'>
                                <AiOutlineSearch size={18} className='text-gray-600' />
                                <input 
                                    type="text"
                                    placeholder={label || initalValue || 'Search'}
                                    className='placeholder-gray-400 p-2 outline-none text-xs w-full bg-gray-100'
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value.toLowerCase())}
                                />
                            </div>
                        </div>
                    )}
                    <div>{dataList}</div>
                </ul>
            )}
            {invalidMsg && <div className='text-xs text-red-500'>{invalidMsg}</div>}
        </div>
    );
};

export default MwSelector;
